import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ErrorDialog({dialogState}) {

    const {dialogError, setDialogError} = dialogState;    
    const {title, text, show} = dialogError;

    const closeHandler=()=>{
        setDialogError({show:false});
    };

    return (
        <>
        <Modal show={show} onHide={closeHandler}>
            <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{text}</Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={closeHandler}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default ErrorDialog;